import React from 'react';
import { Label } from '@atlaskit/form';
import Heading from '@atlaskit/heading';
import Toggle from '@atlaskit/toggle';
import { useIntl } from '@atlassian/jira-intl';
import {
	FeatureContainer,
	FeatureSubtitle,
	FeatureTextContainer,
	FeatureToggle,
	FeatureToggleText,
} from '../../../common/ui/styled';
import messages from './messages';

export type FeatureSectionProps = {
	featureKey: string;
	value: boolean;
	onUpdateFeature: (featureKey: string, value: boolean) => void;
};

export const ParallelSprintFeatureSection = (props: FeatureSectionProps) => {
	const { featureKey, value, onUpdateFeature } = props;
	const { formatMessage } = useIntl();

	return (
		<FeatureContainer
			key={featureKey}
			data-testid="products-jsw-configuration-main.ui.features-section.parallel-sprints.parallel-sprint-feature-section"
		>
			<FeatureTextContainer>
				<Heading size="small" as="h2">
					{formatMessage(messages.parallelSprintsTitle)}
				</Heading>
			</FeatureTextContainer>
			<FeatureToggleText>
				<FeatureSubtitle>
					<Label htmlFor="toggle-feature-parallel-sprints">
						{formatMessage(messages.parallelSprintsDescription)}
					</Label>
				</FeatureSubtitle>
			</FeatureToggleText>
			<FeatureToggle>
				<Toggle
					id="toggle-feature-parallel-sprints"
					name={featureKey}
					label={
						value
							? formatMessage(messages.parallelSprintsToggleLabelOptingIn)
							: formatMessage(messages.parallelSprintsToggleLabelOptingOut)
					}
					isChecked={value}
					onChange={() => {
						onUpdateFeature(featureKey, !value);
					}}
				/>
			</FeatureToggle>
		</FeatureContainer>
	);
};
